import { AfterViewInit, Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TrimFormControl } from '../../form-controls/trim-form-control.form-control';
import { ReleaseCommentDialogService } from './release-comment-dialog.service';

@Component({
  selector: 'prism-release-comment-dialog',
  templateUrl: './release-comment-dialog.component.html',
  styleUrls: ['./release-comment-dialog.component.scss'],
})

export class ReleaseCommentDialogComponent implements OnInit, AfterViewInit {

  public dialogWidth$: BehaviorSubject<number> = new BehaviorSubject<number>(800);
  public dialogLeftPosition$: BehaviorSubject<number> = new BehaviorSubject<number>(0);


  formGroup: FormGroup<{
    comment: TrimFormControl<string>
  }> = new FormGroup({
    comment: new TrimFormControl<string>('', Validators.required)
  });

  constructor(
    public dialogService: ReleaseCommentDialogService
  ) { }

  ngOnInit(): void {
    if (!!this.dialogService.aiComment$.value) {
      this.formGroup.controls.comment.setValue(this.dialogService.aiComment$.value)
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateWidth();
    });
  }

  @HostBinding('style.--child-scale')
  get childScale() {
    return this.dialogService.styleVariableScale; // Return the input value
  }


  // resize
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateWidth();
  }


  public submitResponse() {

    if (this.formGroup.valid) {

      let response = {
        comment: this.formGroup.controls.comment.value || ''
      }

      this.dialogService.response$.next(response)
    }
  }

  private updateWidth() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 800) {
      this.dialogWidth$.next(screenWidth * 0.9);
    } else {
      this.dialogWidth$.next(800 * this.dialogService.styleVariableScale);
    }

    this.dialogLeftPosition$.next((screenWidth - this.dialogWidth$.value) / 2);
  }

  public cancel(){
    this.dialogService.destroyDialog();
  }


}